const get = storage => key => defaultValue => {
  const value = storage.getItem(`RECRUITER_${key}`);
  if (!value) return defaultValue;
  try {
    return JSON.parse(value)?.data;
  } catch (error) {
    console.error(error);
    remove(`RECRUITER_${key}`);
  }
};

const set = storage => key => value =>
  storage.setItem(`RECRUITER_${key}`, JSON.stringify({ data: value }));

const remove = storage => key => () => storage.removeItem(`RECRUITER_${key}`);

/**
 *
 * @param {string} key
 * @param {Storage} storage
 * @returns
 */
const getManager = (key, storage = window.localStorage) => {
  if (!key) throw new Error(`useStorage required key.`);
  return {
    get: get(storage)(key),
    set: set(storage)(key),
    remove: remove(storage)(key),
  };
};

export const useLocalStorage = key => getManager(key, localStorage);
export const useSessionStorage = key => getManager(key, sessionStorage);
